import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    logo: {
        width: theme.spacing(25),
        height: theme.spacing(5),
    },
}));
